export default {
	methods: {
		createString (string, array, isBold, isHighlight) {
			if (!string) { return false }
			let text = string
			array.forEach((item, index) => {
				if (isBold) {
					let styleClass = isHighlight ? 'class="color-primary"' : ''
					item = `<strong ${styleClass}>${item}</strong>`
				}
				text = text.replace(`{${index}}`, item)
			})
			return text
		}
	}
}
